import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoggedInOfficer, OfficerDetailFacade } from '@intrensic/shared/officer-details';
import { BaseApiService } from '@shared/data-access';
import { UserRole } from '@shared/utils/base-auth';
import { EvidenceLabelingResponse, SearchUnlabeledEvidencesDate } from '@shared/utils/evidence-management';
import { AppRoutes, BaseNavigationService, DefaultRoutes } from '@shared/utils/navigation';
import { Observable, map, of, switchMap, take, zip } from 'rxjs';
import { ProductionTypesService } from '@shared/utils/app-config';

@Injectable({
  providedIn: 'root',
})
export class NavigationService extends BaseNavigationService {
  constructor(
    private router: Router,
    private officerDetailsFacade: OfficerDetailFacade,
    private baseApiService: BaseApiService,
    private productionTypesService: ProductionTypesService
  ) {
    super();
  }

  override navigate(checkForRootPath: boolean = true): Observable<void> {
    if (checkForRootPath && window.location.pathname !== '/' && window.location.href !== window.origin) {
      this.router.navigateByUrl(window.location.pathname + window.location.search);

      return of();
    }

    return this.officerDetailsFacade.getLoggedInOfficer().pipe(
      take(1),
      switchMap((loggedInOfficer) => {
        const date = new Date();
        date.setHours(0, 0, 0, 0);

        return zip<[boolean | undefined, LoggedInOfficer]>([
          loggedInOfficer.role === UserRole.HRAdmin || loggedInOfficer.role === UserRole.Kiosk
            ? of(undefined)
            : this.baseApiService
                .post<EvidenceLabelingResponse>('api/files/processing', new SearchUnlabeledEvidencesDate(date.toISOString()))
                .pipe(map((response) => response.UnprocessedFiles.length > 0)),
          of(loggedInOfficer),
        ]);
      }),
      switchMap(([hasUnprocessedFiles, loggedInOfficer]) => {
        let userNavigation = DefaultRoutes[loggedInOfficer.role];

        if (!this.productionTypesService.isProductionTypeIndustrialCam() && hasUnprocessedFiles) {
          if ([UserRole.User, UserRole.Prosecutor, UserRole.SuperAdmin, UserRole.Supervisor, UserRole.Commander].includes(loggedInOfficer.role)) {
            userNavigation = `/${AppRoutes.Files}/processing`;
          }
        }

        if (userNavigation) {
          this.router.navigateByUrl(userNavigation);
        } else {
          this.router.navigate(['forbidden']);
        }

        return of();
      })
    );
  }
}
